import { Box, Table } from '@radix-ui/themes';
import type { PriceEntry } from '@/types';
import { formatPrice, formatTimeRange, isCurrentPeriod } from '@/lib/utils';

interface PriceTableProps {
  prices: PriceEntry[];
}

export function PriceTable({ prices }: PriceTableProps) {
  return (
    <Box style={{ overflowX: 'auto' }}>
      <Table.Root>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Tid</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell align="right">Pris (öre/kWh)</Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {prices.map((price) => {
            const isCurrent = isCurrentPeriod(price.deliveryStart, price.deliveryEnd);
            return (
              <Table.Row
                key={price.deliveryStart}
                style={{
                  backgroundColor: isCurrent ? 'var(--green-a3)' : undefined,
                  fontWeight: isCurrent ? 'bold' : undefined,
                }}
              >
                <Table.Cell>
                  {formatTimeRange(price.deliveryStart, price.deliveryEnd)}
                  {isCurrent && ' (nu)'}
                </Table.Cell>
                <Table.Cell align="right">{formatPrice(price.priceOreKwh)}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Root>
    </Box>
  );
}
